import React from 'react';
import { ListChecks } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { useTramiteTareasSummary } from '../hooks/useTramiteTareasSummary';
import { useTramiteTareasDialog } from '../hooks/useTramiteTareasDialog';
import { TramiteTareasDialog } from './TramiteTareasDialog';
import type { TareasCountSource } from '../types';

interface TareasHeaderBadgeProps {
  tramite: TareasCountSource;
  /** Se llama tras cada mutación exitosa del checklist (ver `TramiteTareasDialog`). */
  onChanged?: () => void;
}

/**
 * Badge compacto de tareas para `HeaderTramite`, el punto más top-level de
 * `/dashboard`. Abre el mismo `TramiteTareasDialog` que el resto de la app.
 */
export const TareasHeaderBadge: React.FC<TareasHeaderBadgeProps> = ({ tramite, onChanged }) => {
  const { total, completadas } = useTramiteTareasSummary(tramite);
  const { isOpen, selectedTramite, openDialog, closeDialog } = useTramiteTareasDialog();

  return (
    <>
      <Badge
        variant="outline"
        className="cursor-pointer px-2 py-1 hover:opacity-80"
        onClick={() => openDialog(tramite)}
        aria-label={
          total === 0
            ? `Agregar tareas a la escritura ${tramite.id}`
            : `Ver tareas de la escritura ${tramite.id}: ${completadas} de ${total} completadas`
        }
      >
        <ListChecks className="h-3.5 w-3.5" />
        {total === 0 ? 'Tareas: agregar' : `Tareas ${completadas}/${total}`}
      </Badge>

      <TramiteTareasDialog
        tramite={selectedTramite}
        isOpen={isOpen}
        onClose={closeDialog}
        onChanged={onChanged}
      />
    </>
  );
};

export default TareasHeaderBadge;
